export default "__VITE_ASSET__WWxJDGL$__"